const INIT_STATE = { user: null, jwt: null };

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case 'auth/LOGIN':
      return { ...state, jwt: action.jwt, user: action.user };
    case 'auth/LOGOUT':
      return INIT_STATE;
    case 'data/update/USERS':
      return { ...state, user: (state.user.id === action.id) ? { ...state.user, ...action.changes } : state.user };
    default:
      return state;
  }
}
